import "../../App.css";
import Table from "react-bootstrap/Table";
import Spinner from 'react-bootstrap/Spinner';


function PlaceHolderTable(){

  return  (
    <Table striped bordered hover>
        <thead>
            <tr>
                <th>
                    <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                </th>
            </tr>
        </thead>
        <tbody>
            <tr key={"placeholder"}><td><Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /></td></tr>
        </tbody>
    </Table>
    );
}

export default PlaceHolderTable;